'use client';

import { useState } from 'react';

import { Button } from '../../../components/Clickables/Buttons/Button';
import { InternalLink } from '../../../components/Clickables/InternalLink/InternalLink';
import { Container } from '../../../components/Container/Container';
import { Heading } from '../../../components/Heading/Heading';
import { ArrowRightIcon } from '../../../components/Icons/ArrowRightIcon';
import { ChevronDownIcon } from '../../../components/Icons/ChevronDownIcon';
import { ChevronUpIcon } from '../../../components/Icons/ChevronUpIcon';
import { StarIcon } from '../../../components/Icons/StarIcon';
import { Text } from '../../../components/Text/Text';
import { ISEOWaterByRegion } from '../../../constants/fishingWaters/constants';
import { getFishingWaterUrl } from '../../../helpers/urls';

interface IProps {
  anglerReccomendedWatersList: ISEOWaterByRegion;
  regionName: string;
}

export const AnglerReccomendedWaters = ({ anglerReccomendedWatersList, regionName }: IProps) => {
  const description = `Our Fishbrain anglers recommend these top spots to fish in ${regionName}`;
  const [showMore, setShowMore] = useState<boolean>(false);

  return (
    <Container className="-px-6 sm:-px-11 md:-px-14 my-6" data-testid="AnglerReccomendedWaters">
      <div className="bg-clownfish-tint p-6 sm:p-11 md:px-14">
        <div className="bg-sea-foam rounded-lg p-4">
          <Heading as="h3" className="pb-3" variant="md">
            Our anglers recommend
          </Heading>
          <Text>{description}</Text>
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-4">
            {anglerReccomendedWatersList.reccomendedWaters.map((water, index) => {
              const { locationName, fishingWaterId } = water;
              const ariaLabel = `Go to ${locationName} page`;

              return (
                <InternalLink
                  key={fishingWaterId}
                  to={getFishingWaterUrl(fishingWaterId, locationName)}
                  aria-label={ariaLabel}
                  className={`bg-clownfish-tint flex items-center justify-between rounded-lg p-3 ${index > 3 && !showMore ? 'hidden' : ''} `}
                >
                  <div className="flex items-center">
                    <div className="text-clownfish mr-2">
                      <StarIcon />
                    </div>
                    {locationName}
                  </div>

                  <ArrowRightIcon />
                </InternalLink>
              );
            })}
          </div>
          <div className="mt-1 flex h-full justify-center">
            {!showMore ? (
              <Button
                variant="textPrimary"
                onClick={() => {
                  setShowMore(true);
                }}
                className="size-10"
              >
                <ChevronDownIcon size={28} />
              </Button>
            ) : (
              <Button
                variant="textPrimary"
                onClick={() => {
                  setShowMore(false);
                }}
                className="size-10"
              >
                <ChevronUpIcon size={28} />
              </Button>
            )}
          </div>
        </div>
      </div>
    </Container>
  );
};
